import React from "react";
import TableHeader from "@components/TableHeader";
import Printfiled from "./Printfiled";

const Hosting = (props) => {
  const header = [
    {
      title: "tarif_date",
      width: 7,
      align: "left",
      filed: "date",
    },

    {
      title: "base_amount",
      width: 18,
      align: "center",
      filed: "base_amount",
      filedList: ["price"],
    },
    {
      title: "charge",
      width: 18,
      align: "center",
      filed: "charge",
      filedList: ["price"],
    },
    {
      title: "amount_traveler",
      width: 18,
      align: "center",
      filed: "amount_traveler",
      filedList: ["price"],
    },
    {
      title: "you_earn",
      width: 18,
      align: "center",
      filed: "you_earn",
      filedList: ["price"],
    },
    { title: "", width: 5, align: "center", filed: "is_stop_sales" },
    { title: "", width: 5, align: "center", filed: "button" },
  ];
  return (
    <>
      <p className="mt-1 fw-normal">{props.t("ho_act_Opt_TarifTxt1")}</p>

      <div class="tableFixHead">
        <TableHeader header={header} />
        <table>
          <tbody>
            {props.prices.map((item, index) => (
              <tr>
                {header.map((head) => (
                  <td className="cell100" style={{ textAlign: head.align }}>
                    <Printfiled
                      tarif={item}
                      filed={head.filed}
                      filedList={head?.filedList}
                      onStopSales={props.onStopSales}
                      priceForm={props.priceForm}
                      config={props.config}
                      dataIndex={{
                        item: item,
                        index: item,
                      }}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};
export default Hosting;
